var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getLineStyle, getTextStyle, getShapeStyle } from '../utils/styleHelper';
import merge from '../utils/merge';
var modelId = 0;
var Model = /** @class */ (function () {
    function Model(option) {
        if (option === void 0) { option = {}; }
        this._eventHandles = {};
        this.option = merge(this.getDefaultOption(option), option);
        this.id = modelId.toString();
        modelId += 1;
    }
    Model.prototype.mounted = function () {
        var events = this.getEvents();
        for (var eventName in events) {
            var handleFunction = events[eventName];
            var bindFunction = handleFunction.bind(this);
            this._eventHandles[eventName] = bindFunction;
            this.chart.on(eventName, bindFunction);
        }
    };
    // eslint-disable-next-line no-unused-vars
    Model.prototype.getDefaultOption = function (option) {
        return {};
    };
    Model.prototype.getOption = function () {
        return this.option;
    };
    Model.prototype.getKey = function (key) {
        return this.type + "-" + this.id + "-" + key;
    };
    Model.prototype.getEvents = function () {
        return {};
    };
    Model.prototype.getTextStyle = function (option) {
        var defaultTextStyle = getTextStyle(this.chart.getOption().textStyle);
        var style = getTextStyle(option);
        return __assign(__assign({}, defaultTextStyle), style);
    };
    Model.prototype.getLineStyle = function (option) {
        return getLineStyle(option);
    };
    Model.prototype.getShapeStyle = function (option) {
        return getShapeStyle(option);
    };
    Model.prototype.beforeRender = function () { };
    Model.prototype.render = function () {
        return null;
    };
    Model.prototype.afterRender = function () { };
    Model.prototype.destroy = function () {
        for (var eventName in this._eventHandles) {
            this.chart.off(eventName, this._eventHandles[eventName]);
        }
        this.chart = undefined;
        this._eventHandles = {};
    };
    return Model;
}());
export default Model;
